import React, { useEffect, useRef, useState } from 'react';
import {
  HiX,
  HiCheckCircle,
  HiExclamationCircle,
  HiInformationCircle,
} from 'react-icons/hi';
import './Notification.css';

const Notification = ({
  message,
  type = 'info',
  onClose,
  duration = 4500,
}) => {
  const [isVisible, setIsVisible] = useState(true);
  const onCloseRef = useRef(onClose);
  const closedRef = useRef(false);

  useEffect(() => {
    onCloseRef.current = onClose;
  }, [onClose]);

  // Animação de saída alinhada à duração (sem depender da identidade de onClose)
  useEffect(() => {
    closedRef.current = false;
    setIsVisible(true);

    if (!(duration > 0)) {
      return undefined;
    }

    const hideTimer = setTimeout(() => {
      setIsVisible(false);
    }, duration);

    return () => clearTimeout(hideTimer);
  }, [duration]);

  const handleClose = () => {
    if (closedRef.current) return;
    closedRef.current = true;
    setIsVisible(false);
    setTimeout(() => {
      onCloseRef.current?.();
    }, 300);
  };

  const getIcon = () => {
    switch (type) {
      case 'success':
        return <HiCheckCircle size={20} />;
      case 'error':
        return <HiExclamationCircle size={20} />;
      case 'warning':
        return <HiExclamationCircle size={20} />;
      default:
        return <HiInformationCircle size={20} />;
    }
  };

  return (
    <div
      className={`notification notification-${type}${
        isVisible ? ' notification-show' : ' notification-hide'
      }`}
      role="status"
      aria-live="polite"
    >
      <div className="notification-icon">{getIcon()}</div>
      <div className="notification-message">{message}</div>
      <button
        type="button"
        className="notification-close"
        onClick={handleClose}
        aria-label="Fechar notificação"
      >
        <HiX size={18} />
      </button>
    </div>
  );
};

export default Notification;
